import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardTitle } from '@parrot-software/design-system';

import { RecommendButton } from './RecommendButton';

interface ReferralClosingBannerProps {
  whatsappLink: string;
}

/**
 * Closing banner (design-system Card) with the final referral message and a second WhatsApp CTA.
 * Text and button sit side by side on desktop and stack on mobile.
 *
 * @param {ReferralClosingBannerProps} props - Component properties
 * @returns {React.ReactElement} The closing banner
 */
export const ReferralClosingBanner = ({ whatsappLink }: ReferralClosingBannerProps) => {
  const { t } = useTranslation('referral');

  return (
    <Card>
      <CardContent className="flex flex-col gap-5 p-6 md:flex-row md:items-center md:justify-between md:gap-8 md:p-8">
        <div className="flex flex-col gap-1.5">
          <CardTitle className="text-2xl">{t('closingBanner.title')}</CardTitle>
          <CardDescription>{t('closingBanner.subtitle')}</CardDescription>
        </div>

        <RecommendButton className="w-fit shrink-0" href={whatsappLink} label={t('cta.recommend')} />
      </CardContent>
    </Card>
  );
};
